import React from 'react';
import './BottomNav.css';

const BottomNav = ({ activePage, onNavigate }) => {
  const navItems = [
    { id: 'home', label: 'Home', icon: '🏠', href: '#home' },
    { id: 'about', label: 'About', icon: 'ℹ️', href: '#about' },
    { id: 'contact', label: 'Contact', icon: '📧', href: '#contact' }
  ];

  const handleClick = (e, item) => {
    e.preventDefault();
    onNavigate(item.id);
  };

  return (
    <nav className="bottom-nav">
      {navItems.map(item => (
        <a
          key={item.id}
          href={item.href}
          onClick={(e) => handleClick(e, item)}
          className={`bottom-nav-item ${activePage === item.id ? 'active' : ''}`}
        >
          <span className="bottom-nav-icon">{item.icon}</span>
          <span className="bottom-nav-label">{item.label}</span>
        </a>
      ))}
    </nav>
  );
};

export default BottomNav;
